<template>
  <div class="trade-settlement-page" :class = "{'clear-header':isWechatBrowser}">
    <my-header v-if="!isWechatBrowser" title="提交订单" :showBack="true"></my-header>
    <div class="address-info default-top-bg">
      <div class="default-address">
        <div class="default-address-detail" @click="editAddress(defaultAddress.id)">
          <img src="../../assets/icon/icon-address.png">
          <div class="address-detail">{{address.receiver}}</div>
          <div class="address-detail" style="flex-grow: 1;margin-top:0.05rem;">{{address.phone}}</div>
        </div>
        <div class="default-address-down">
          <div class="address-content">{{address.address}}</div>
        </div>
      </div>
    </div>
    <div v-if="orderList.length > 0" v-for="item in orderList" class="customer-cart-part-item general-box-shadow">
      <div class="shop-info">{{item.dealerShop.name}}</div>
      <div v-for="orderDetailItem in item.tradeOrderDetailList" class="product-info">
        <img class="product-img" :src="orderDetailItem.productImage">
        <div class="product-sku">
          <div class="product-name">{{orderDetailItem.productEntity.name}}</div>
          <div class="sku-item">
            <div>数量：{{orderDetailItem.quantity}}</div>
          </div>
          <div class="product-price">¥ <span>{{orderDetailItem.price * orderDetailItem.quantity}}</span></div>
        </div>
      </div>
    </div>
    <div class="btn-part">
      <div class="prepay-money">需付：<span class="money">¥ <span class="num">{{prepayAmount}}</span></span></div>
      <div @click="payMoney" class="general-btn general-confirm-btn">去支付</div>
    </div>
  </div>
</template>

<script>
  import {Toast} from 'mint-ui'
  import Header from '../../components/header/Header'
  import payUtil from '../../utils/Pay'
  import {imgUrl} from "../../config";
  import tradeOrderService from '../../service/trade/TradeOrderService'

  export default {
    name: 'Settlement',
    components: {
      'my-header': Header,
    },
    data () {
      return {
        errorMsg:'',
        prePayInfo:{},
        imgUrl: imgUrl,
        cartIds:[],
        address:{},
        orderList:[],
        prepayAmount:0,
        isWechatBrowser:this.$verfyBrowserType()
      }
    },
    created(){
      this.cartIds = this.$route.query.cartIds;
    },
    beforeMount () {
      document.title = this.$route.meta.title;
      this.createOrder();
    },
    methods: {
      async createOrder(){
        let {code,msg,data} = await tradeOrderService.createOrder(this.cartIds);
        if(code == '0'){
          this.address = data.address;
          this.orderList = data.orderList;
          console.info(this.orderList)
          for(let order of this.orderList){
            this.prepayAmount = this.prepayAmount + order.finalAmount;
          }
        }else {
          Toast(msg);
        }
      },
      backCustomerCart(){
        this.$router.push({name: 'CustomerCart'})
      },
      toAddressList(){
        this.$router.push({name: 'AddressList'})
      },
      async payMoney(){
        //判断浏览器类型
        let ua = navigator.userAgent.toLowerCase();
        if(ua.match(/MicroMessenger/i) == 'micromessenger') {
          let result = await tradeOrderService.saveAndPayOrder(this.address.id,this.cartIds,'1');
          if(result.code == '0'){
            this.prePayInfo = payUtil.pay(result.data.prepayId,result.data.nonceStr);
            if(this.global.isMiniProgrm){
              wx.miniProgram.navigateTo({url: '/pages/payH5/index/index?payData='+encodeURIComponent(encodeURIComponent(JSON.stringify(this.prePayInfo)))});
            }
            let requestPay = this.requestPay;
            if (typeof WeixinJSBridge == "undefined"){
              if( document.addEventListener ){
                document.addEventListener('WeixinJSBridgeReady', requestPay, false);
              }else if (document.attachEvent){
                document.attachEvent('WeixinJSBridgeReady', requestPay);
                document.attachEvent('onWeixinJSBridgeReady', requestPay);
              }
            }else{
              this.requestPay();
            }
          } else {
            Toast(result.msg);
          }
        }else {
          let result = await tradeOrderService.saveAndPayOrder(this.address.id,this.cartIds,'2');
          if(result.code == '0'){
            let payCallBackUrl = result.data.mwebUrl + '&redirect_url=' + window.location.href;
            window.location.href = payCallBackUrl;
          }else {
            Toast(result.msg);
          }
        }

      },
      requestPay(){
        let prePayInfo = this.prePayInfo;
        let that = this;
        try {
          WeixinJSBridge.invoke(
            'getBrandWCPayRequest',
            {
              "appId":prePayInfo.appId,     //公众号名称，由商户传入
              "timeStamp":prePayInfo.timeStamp,         //时间戳，自1970年以来的秒数
              "nonceStr":prePayInfo.nonceStr, //随机串
              "package":prePayInfo.package,
              "signType":prePayInfo.signType,         //微信签名方式：
              "paySign":prePayInfo.paySign //微信签名
            },
            function(res){
              if(res.err_msg == "get_brand_wcpay_request:ok" ) {
                that.$router.push({name:'TradeOrderList'});
              } else if(res.err_msg == "get_brand_wcpay_request:cancel" ){
                that.$router.go(-1);
              }else {
                Toast('支付失败!');
                that.errorMsg = JSON.stringify(res)
              }// 使用以上方式判断前端返回,微信团队郑重提示：res.err_msg将在用户支付成功后返回    ok，但并不保证它绝对可靠。
            },function (e) {
              console.error("支付失败err!"+JSON.stringify(e));
              Toast("支付失败!"+JSON.stringify(e));
            });
        }catch (e){
          console.error("支付失败-----!"+JSON.stringify(e));
          Toast("支付失败!"+JSON.stringify(e));
        }
      },
    }
  }
</script>
<style lang="scss">
  @import '../../assets/style/common.scss';
  .trade-settlement-page {
    font-size: 0.32rem;
    .address-info{
      color: #1b1e29;
      padding: 0 0.3rem;
      margin-bottom:  0.24rem;
      font-size: 0.28rem;
      .default-address{
        .default-address-detail{
          display: flex;
          padding-top: 0.3rem;
          padding-bottom: 0.1rem;
        }
        .default-address-down{
          display: flex;
          align-items: center;
        }
        .default-address-detail img{
          width: 0.35rem;
          height: 0.42rem;
          margin-top: 0.04rem;
        }
        .address-detail{
          margin-left: 0.2rem;
          font-size: 0.36rem;
          color: white;
          font-weight: bold;
        }
        .default-address-detail-up{
          margin-left: 0.15rem;
          margin-right: 0.25rem;
        }
        .address-content{
          color: white;
          padding-left: 0.52rem;
        }
      }
    }
    .shop-info{
      width: 6.3rem;
      height: 0.89rem;
      line-height: 0.9rem;
      margin: 0 auto 0.3rem auto;
      border-bottom: solid 1px #e0dedc;
    }
    .customer-cart-part-item{
      width: 6.9rem;
      margin: 0 auto 0.3rem;
      padding-bottom: 0.3rem;
      .product-info{
        margin-bottom: 0.3rem;
        display:flex;
        position:relative;
        .product-img{
          width: 2.3rem;
          height: 2.3rem;
          margin-left: 0.3rem;
          border-radius: 0.06rem;
        }
        .product-sku{
          padding-left: 0.2rem;
          .product-name{
            width: 4rem;
            margin-bottom: 0.2rem;
            font-size: 0.36rem;
            font-weight: bold;
          }
          .sku-item{
            display: flex;
            justify-content: space-between;
            width: 3.8rem;
            font-size: 0.28rem;
            color: #7f7d7c;
            .del-shop-cart{
              width: 0.8rem;
              height: 0.4rem;
              background-color: #fff7e5;
              border-radius: 0.2rem;
              font-size: 0.24rem;
              line-height: 0.42rem;
              text-align: center;
              color: #feac00;
            }
          }
          .product-price{
            margin-top: 0.1rem;
            font-size: 0.32rem;
            font-weight: bold;
            color: #d54a33;
            span{
              font-size: 0.4rem;
            }
          }
        }
      }
    }
    .prepay-money{
      display: flex;
      justify-content: flex-end;
      height: 0.7rem;
      line-height: 0.75rem;
      padding-right: 0.3rem;
      font-size: 0.28rem;
      color: #191818;
      font-weight: bold;
      .money{
        color: #d54a33;
        font-size: 0.32rem;
        .num{
          font-size: 0.4rem;
        }
      }
    }
    .btn-part{
      display: flex;
      justify-content: flex-end;
    }
    .general-confirm-btn{
      width: 1.9rem;
      height: 0.7rem;
      margin-right: 0.36rem;
      background-color: #feac00;
      border: none;
      color: white;
    }
  }
</style>
